"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMask = void 0;
const isFixed = (maskChar) => '0#A'.indexOf(maskChar) === -1;
// 0 = single digit
// # = at least 1 digit
// A = single letter
// TODO: X = obscured letter
// TODO: * = obscured number
// anything else: literal character
const matchesPattern = (c, maskChar) => {
    const mustAdvance = maskChar !== '#';
    let matches = c === maskChar;
    if (maskChar === '0' || maskChar === '#') {
        matches = c.match(/[0-9]/) !== null;
    }
    else if (maskChar === 'A') {
        matches = c.match(/[a-zA-Z]/) !== null;
    }
    return [matches, mustAdvance];
};
const applyMask = (mask, value) => {
    // Apply no formatting if mask is empty
    if (mask === '') {
        return [value, value];
    }
    let rawValue = '';
    let maskedValue = '';
    let maskIndex = 0;
    let fixed = '';
    for (let i = 0; i < value.length; i += 1) {
        const c = value[i];
        let maskChar = mask[maskIndex];
        // if a character is inputted that matches the mask character after a '#',
        // advance the mask character past the #
        const fixedAfterVarying = maskChar === '#' && mask[maskIndex + 1] === c;
        if (fixedAfterVarying) {
            maskIndex += 1;
            maskChar = mask[maskIndex];
        }
        // If the current mask character is fixed (e.g. not 0, #, or A), get all of the
        // subsequent masked characters
        // For example: in '(000) 000-0000' when '(000' is inputted, this loop makes
        // fixed = ') ' since that is the next matching block of fixed characters
        // Then, if another character is inputted and matched, we add 'fixed' to maskedValue
        for (; maskIndex < mask.length; maskIndex += 1) {
            maskChar = mask[maskIndex];
            if (isFixed(maskChar)) {
                fixed += maskChar;
            }
            else {
                break;
            }
        }
        maskChar = mask[maskIndex];
        // Add the fixed segment immediately (even if there is nothing following
        // This enables (for example) inserting a `.` after a '#' block
        // Otherwise, the trailing `.` would always be removed
        // If this condition is not met, then the fixed segment is added when
        // the next character matches
        if (fixedAfterVarying) {
            maskedValue += fixed;
            fixed = '';
        }
        if (maskIndex === mask.length) {
            break;
        }
        const [matches, mustAdvance] = matchesPattern(c, maskChar);
        if (matches) {
            // Add in the fixed characters now that we have matched the next character
            maskedValue += fixed;
            fixed = '';
            rawValue += c;
            maskedValue += c;
            // Don't advance on `#` since it can match multiple characters
            if (mustAdvance) {
                maskIndex += 1;
            }
        }
    }
    return [rawValue, maskedValue];
};
exports.applyMask = applyMask;
